import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    setTimeout(() => this.dispatch('connected'));
  }

  display(event) {
    const { item } = event.detail;

    const blobUrl = URL.createObjectURL(item);
    this.element.src = blobUrl;
    this.element.onload = () => URL.revokeObjectURL(blobUrl);
  }
}
